import Auth from '../api/auth';
import { clearCookiesOnLogout } from '../store/utils/api';

let isUnauthorizedLogoutInProgress = false;

const shouldForceLogout = error =>
  error?.response?.status === 401 && Auth.hasAuthCookie();

const parseErrorCode = error => {
  if (shouldForceLogout(error) && !isUnauthorizedLogoutInProgress) {
    isUnauthorizedLogoutInProgress = true;
    clearCookiesOnLogout();
  }

  return Promise.reject(error);
};

export default axios => {
  const { apiHost = '' } = window.chatwootConfig || {};
  const wootApi = axios.create({ baseURL: `${apiHost}/` });
  // Add Auth Headers to requests if logged in
  if (Auth.hasAuthCookie()) {
    const {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    } = Auth.getAuthData();
    Object.assign(wootApi.defaults.headers.common, {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    });
  }
  // Response parsing interceptor
  wootApi.interceptors.response.use(
    response => response,
    error => parseErrorCode(error)
  );
  return wootApi;
};
